import type { UserBase } from '@core/account-types';
import type { MentionElement } from '@core/prosemirror-legacy';
import { MentionType } from '@core/prosemirror-legacy';

export const userToMention = (user: UserBase, additionalFields?: any): MentionElement => ({
  id: user.id,
  type: MentionType.User,
  name: `${user.firstName} ${user.lastName}`,
  avatar: user.photoThumbUrl,
  entity: user,
  hasAvatar: user.hasAvatar,
  initials: user.initials,
  ...additionalFields,
});
